import {State} from '../state';
import {createSelector, MemoizedSelector} from '@ngrx/store';
import {selectBpmnModelerState} from './bpmn-modeler-state.selector';
import {MapUtils} from "@ispm/shared/utils/Map.utils";
import {ModelingUtil} from "@ispm/shared/bpmn-io/modeling-util";

const getFloatedNodesMap = (state: State): Map<string, Array<string>> => state.floatedNodes;

export const selectFloatedNodesMap: MemoizedSelector<object, Map<string, Array<string>>> =
    createSelector(selectBpmnModelerState, getFloatedNodesMap);


export const selectFloatedNodesByLayer = (layer: string) => createSelector(
    selectFloatedNodesMap,
    floatedNodesMap => floatedNodesMap.get(layer));

export const selectFloatedNodesByIdAndByLayer = (layer: string, id: string) => createSelector(
    selectFloatedNodesMap,
    floatedNodes => floatedNodes.has(layer) ? floatedNodes.get(layer).find(floatNodeId => floatNodeId === id) : undefined);

export const selectFloatedNodesObject = (layer: string) => createSelector(
  selectFloatedNodesMap,
  floatedNodesMap => MapUtils.convertFromMapToObject(floatedNodesMap));

export const selectNumberOfFloatedNodesByLayer = (layer: string, elementsRegistry: any, ignoreNodesIds: String[]) => createSelector(
  selectFloatedNodesMap,
    floatedNodes => floatedNodes.has(layer) ? floatedNodes.get(layer).
    filter((node) => !ModelingUtil.hasDeletionTrackingChange(elementsRegistry.get(node)) && !ignoreNodesIds.includes(node)).length : 0);

